module.exports = __webpack_public_path__ + "static/media/buy1.51ed1ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/buy/buy1.png
// module id = 1091
// module chunks = 0